import { useContext } from "react";
import { CouponContext } from "../context/CouponContext";

const useCoupon = () => {
  return useContext(CouponContext);
};

export default useCoupon;
